import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "./redux";
import { deleteSession } from "../store/slices/chatSlice";

export const useSessionCleanup = () => {
  const dispatch = useAppDispatch();
  const { currentSessionId } = useAppSelector((state) => state.chat);

  useEffect(() => {
    const handleBeforeUnload = () => {
      // Clean up session when page is about to unload
      if (currentSessionId && !currentSessionId.startsWith("temp-")) {
        navigator.sendBeacon(
          `https://ragflow.nubeta.de/api/chat/${currentSessionId}`,
          JSON.stringify({ _method: "DELETE" })
        );
      }
    };

    const handleUnload = () => {
      // Fallback cleanup
      if (currentSessionId && !currentSessionId.startsWith("temp-")) {
        dispatch(deleteSession(currentSessionId));
      }
    };

    // Add event listeners
    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("unload", handleUnload);

    // Cleanup function
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("unload", handleUnload);

      // Also cleanup on component unmount (when user navigates away)
      if (currentSessionId && !currentSessionId.startsWith("temp-")) {
        dispatch(deleteSession(currentSessionId));
      }
    };
  }, [currentSessionId, dispatch]);
};
